<div class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseManage();">
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-sm flex flex-col my-6 p-8 bg-white rounded-md shadow-lg overflow-hidden"
            (click)="$event.stopPropagation()">

            <form [formGroup]="manageForm" (ngSubmit)="onSubmit()"
                class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-[#fed7aa]">
                    <h2 class="w-full text-[#f15f3e] oswald-font text-2xl font-medium text-start">Tip Management</h2>
                </div>

                <div class="w-full flex flex-col gap-4 items-start justify-start">
                    <div class="w-full flex items-center justify-start gap-2">
                        <label for="statusSelect" class="w-32 text-left">Change Status:</label>
                        <select id="statusSelect" formControlName="new_status" class="border rounded-md px-3 py-2 text-sm text-gray-500">
                            <option value="0">Open</option>
                            <option value="1">In Review</option>
                            <option value="2">Closed</option>
                        </select>
                    </div>

                    <div class="w-full flex items-start justify-start gap-2">
                        <label for="noteInput" class="w-32 text-left">Note:</label>
                        <textarea id="noteInput" formControlName="note" rows="4"
                            class="grow border rounded-md px-3 py-2 text-sm" placeholder="Enter here"></textarea>
                    </div>
                    <!-- <div *ngIf="manageForm.get('new_status')?.hasError('statusUnchanged') && manageForm.get('new_status')?.touched"
                        class="text-red-500 text-sm italic">
                        Please select a different status from the current one.
                    </div> -->
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end oswald-font">
                    <button type="button" class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400"
                        (click)="handleCloseManage()">
                        Close
                    </button>
                    <button type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.manageForm.invalid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.manageForm.valid
                        }"
                        [disabled]="manageForm.invalid"
                    >
                        Submit
                    </button>
                </div>
            </form>

        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>